import { Injectable } from '@angular/core';
import { Answer } from "../models/answer";

@Injectable({providedIn: 'root'})
export class ArrayUtils {
    public removeFromArrayWithId(data: any[], id: any) {
        const index = data.map((x) => x.id).indexOf(id);

        data.splice(index, 1);

        return data;
    }

    public removeFromArrayByReference(data: any[], object: any) {
        const index = data.indexOf(object);
        if (index !== -1) {
            data.splice(index, 1);
        }

        return data;
    }

    /**
     * Group objects by attribute
     * @param data
     * @param attribute
     * @param attribute2
     * @param attribute3
     * @param attribute4
     */
    public groupByAttribute(data: any, attribute: string, attribute2: string|null = null, attribute3: string|null = null, attribute4: string|null = null) {
      return data?.reduce(function (r: any, a: any) {
        if (attribute4 && attribute3 && attribute2) {
          r[a[attribute]?.[attribute2]?.[attribute3]?.[attribute4]] = r[a[attribute]?.[attribute2]?.[attribute3]?.[attribute4]] || [];
          r[a[attribute]?.[attribute2]?.[attribute3]?.[attribute4]].push(a);
        } else if (attribute3 && attribute2) {
          r[a[attribute]?.[attribute2]?.[attribute3]] = r[a[attribute][attribute2]?.[attribute3]] || [];
          r[a[attribute]?.[attribute2]?.[attribute3]].push(a);
        } else if (attribute2) {
          r[a[attribute]?.[attribute2]] = r[a[attribute]?.[attribute2]] || [];
          r[a[attribute]?.[attribute2]].push(a);
        } else {
          r[a[attribute]] = r[a[attribute]] || [];
          r[a[attribute]].push(a);
        }

        return r;
      }, Object.create(null));
    }

    public filter(data: any, attribute: string, key: string) {
        const dataCopy = JSON.parse(JSON.stringify(data));

        return dataCopy.filter(function(el: any) {
            return el[attribute] === key;
        });
    }

    public capitalize(s: any) {
        if (typeof s !== 'string') {
            return '';
        }

        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    public findAnswerByQuestionIdAthleteId(answers: Answer[], questionId: number, athleteId: number) {
        const result = answers.find(function(answer) {
            return answer.questionId === questionId && answer.athleteId === athleteId;
        });

        return result ? result.value : 0;
    }

    public findAnswerByQuestionIdCoachId(answers: Answer[], questionId: number, coachId: number) {
        const result = answers.find(function(answer) {
            // tous les coachs d'un athlète peuvent modifier les réponses d'un feedback existant
            // return answer.questionId === questionId && answer.coachId === coachId;
            return answer.questionId === questionId && answer.coachId !== null;
        });

        return result ? result.value : 0;
    }

    public findById(data: any[], id: any) {
        return data.find((x:any) => x.id === id);
    }

    /**
     * <pre><code>
     * const pets = [
     * {type:"Dog", name:"Spot"},
     * {type:"Cat", name:"Tiger"},
     * {type:"Dog", name:"Rover"},
     * {type:"Cat", name:"Leo"}
     * ];
     *
     * const grouped = groupBy(pets, pet => pet.type);
     * console.log(grouped.get("Dog"));
     * console.log(grouped.get("Cat"));
     * </code></pre>
     *
     * @param list
     * @param keyGetter
     */
    public groupBy(list: any[], keyGetter: (arg0: any) => any) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    }
}
